import { Form, Input } from '~/shared/components/form';
import { UseFormReturn } from 'react-hook-form';

import { Fields, LoginInputs } from '../models/fields';
import { Container, StyledCTAButton } from '../styled';
import { TranslationKey } from '~/lib';

type ForgotPasswordViewProps = {
    methods: UseFormReturn<LoginInputs>;
    handleResetSendEmail: (payload: LoginInputs) => Promise<void>;
    translate: (key: TranslationKey) => string;
};

export const ForgotPasswordView = ({
    methods,
    handleResetSendEmail,
    translate,
}: ForgotPasswordViewProps) => {
    const isEmailValid = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;

    const emailState = methods.watch(Fields.Email);

    return (
        <>
            <Form methods={methods} onSubmit={handleResetSendEmail}>
                <Container>
                    <Input
                        data-testid="email"
                        name={Fields.Email}
                        autoComplete="email"
                        placeholder={translate('login.email')}
                        required
                    />
                    <StyledCTAButton
                        disabled={!isEmailValid.test(emailState)}
                        data-testid="reset-password-button"
                        type="submit"
                        variant="primary"
                    >
                        {translate('login.resetPassword')}
                    </StyledCTAButton>
                </Container>
            </Form>
        </>
    );
};
